var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AtomImageParallax',{staticClass:"mt-3 md:mt-8 min-h-[238px] aspect-[296/238] md:aspect-[1330/606]",attrs:{"strapi-image-object":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }